import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeLimitBar = style({
    marginTop: 10,
    paddingLeft: 15
})

export const LimitBarTitle = style({
     paddingTop: 15,
     marginBottom: 15,
     height: 35
})

export const WkClampLine = style ({
    width: '80%',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'inline-block'
})

export const LimitBarTitleMain = style({
    width: 'auto',
    maxWidth: 200,
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '18px',
    float: 'left',
    fontWeight: 500
})

export const LimitBarTimeNum = style({
    background: '#333333',
    borderRadius: 3,
    color: '#fff',
    fontSize: 14,
    display: 'inline-block',
    lineHeight: '18px',
    width: 19,
    height: 18,
    textAlign: 'center'
})

export const LimitBarTimePoint = style({
      display: 'inline-block',
      margin: '0 2px'
})

export const LimitBarContent = style({
      'paddingBottom': 15,
      ...csstips.flexRoot,
      'overflow': 'auto',
      '-webkit-overflow-scrolling': 'touch'
})

export const LimitBarItem = style({
      marginRight: 10,
      cursor: 'pointer',
      width: 160,
      minWidth: 160,
      borderRadius: 8,
      $nest: {
          '&:active': {
              opacity: .5
          },
          '&:last-child': {
              paddingRight: 15
          }
      }
})

export const LimitBarItemImage = style ({
      display: 'block',
      borderRadius: '3px 3px 0 0',
      overflow: 'hidden',
      backgroundSize: 'cover',
      height: '24vw',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      position: 'relative',
      maxHeight: 115.2,
      width: 160
 })

export const LimitBarItemName = style({
    bottom: 0,
    ...csstips.flexRoot,
    color: '#FFFFFF',
    fontSize: 14,
    letterSpacing: 0,
    lineHeight: '18px',
    padding: '0 5px',
    paddingBottom: 3,
    fontWeight: 600,
    position: 'absolute',
    height: 30,
    display: 'block',
    width: '100%',
    ...csstips.end,
    background: 'linear-gradient(rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.3) 100%)',
    $nest: {
        '& p': {
            position: 'absolute',
            bottom: 2,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            display: 'block',
            width: '100%'
        }
    }
})

export const LimitBarItemBottom = style({
    ...csstips.flexRoot,
    ...csstips.end,
    background: '#EF303B',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    height: 35,
    padding: '0 2px 4px',
    position: 'relative',
    width: 160
})

export const LimitBarItemFu = style({
      fontSize: 14,
      color: '#FFFFFF',
      letterSpacing: 0,
      lineHeight: '14px'
})

export const LimitBarItemPoint  = style({
      fontSize: 14,
      color: '#FFFFFF',
      letterSpacing: 0,
      lineHeight: '16px'
})

export const LimitBarItemMoney = style({
      position: 'relative',
      top: 2,
      fontSize: 28,
      lineHeight: '30px',
      color: '#FFFFFF',
      letterSpacing: 0,
      marginLeft: '-1px'
})

export const LimitBarItemBd = style({
      display: 'inline-block',
      transform: 'scale(0.5, 0.5) translate(-50%, 100%)',
      marginBottom: 13,
      marginLeft: 5
})

export const LimitBarItemOrigin = style({
        fontSize: 20,
        color: '#FFBFBF',
        letterSpacing: 0,
        lineHeight: '20px',
        display: 'block',
        whiteSpace: 'nowrap',
        textDecoration: 'line-through'
})

export const LimitBarItemPopular = style({
        background: '#D0021B',
        borderRadius: 6,
        fontSize: 20,
        color: '#FFBFBF',
        letterSpacing: 0,
        textAlign: 'center',
        lineHeight: '20px',
        padding: 4,
        // width: 127,
        display: 'block',
        marginTop: '4px',
        $nest: {
            '& span': {
                display: 'block'
            }
        }
})

export const LimitBarItemIcon = style({
    position: 'absolute',
    display: 'block',
    height: 35,
    width: 'auto',
    right: 0,
    top: 0,
    borderBottomRightRadius: 4
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeLimitBar/HomeLimitBar.style.ts